<template src="./template.html"></template>
<script>
  export default ({
    props: {
      name: {
        type: String,
        default: 'form_nt_c1[googleanalytics][client_id]'
      }
    },
    data: function () {
      return {
        client_id: '',
        retry: {
          interval_ms: 200,
          limit: 30,
          counter: 0,
        }
      };
    },
    created() {
      // cookieからGA client_idを取得（ページロード時に実行）
      window.addEventListener('load', () => {
        this.setClientId();
      });
    },
    methods: {
      setClientId() {
        // _ga cookieから直接client_idを取得
        const clientId = this.getClientIdFromCookie();
        if (clientId) {
          this.client_id = clientId;
          return;
        }

        // cookieがまだ設定されていない場合はリトライ
        this.retry.counter++;
        if (this.retry.counter < this.retry.limit) {
          setTimeout(this.setClientId, this.retry.interval_ms);
          return;
        }
      },
      getClientIdFromCookie() {
        // _ga=GA1.1.123456789.1234567890 の形式からclient_idを抽出
        const cookie = document.cookie.split(';').find(c => c.trim().startsWith('_ga='));
        if (!cookie) {
          return null;
        }

        const value = cookie.split('=')[1];
        const parts = value.split('.');
        // GA1.1.{client_id}.{timestamp} の形式なので、後ろ2つを結合
        if (parts.length >= 4) {
          return parts.slice(2).join('.');
        }

        return null;
      },
    },
  });
</script>